<template>
    <div class="container">
        <div class="row justify-content-center align-items-center py-2 my-3">
            <p class="page-title-header-text mb-0">Select a player below to view their predictions and points for this
                round.</p>
        </div>
        <hr class="line-break">
        <div class="container fluid winnings-container">
            <table class="winnings-table">
                <tr class="table-row-header">
                    <th class="player-names table-header-text">Player</th>
                    <th class="table-header-text">Date</th>
                    <th class="table-header-text">Place</th>
                    <th class="table-header-text">Points</th>
                </tr>
                <tr v-for="(palyer, index) in leaderboardTable" :key="index" class="table-row-data"
                    v-on:click="onPlayerClicked(palyer)">
                    <td class="player-names table-data-text">{{ palyer.Username }} <p
                            v-if="palyer.MSISDN === userData.msisdn">
                        (YOU)</p></td>
                    <td class="table-data-text">{{ formatDate(palyer.EndDate) }}</td>
                    <td class="table-data-text">{{ palyer.Position }}</td>
                    <td class="table-data-text">{{ palyer.Points }}</td>
                    <td>
                        <BIconChevronBarRight class="chevron-bar-right"/>
                    </td>
                </tr>
            </table>
        </div>
        <div class="home-button-box">
            <button v-on:click="routeToRoundsBoard()" class="back-button"><p class="button-text">Back</p></button>
        </div>
        <div class="home-button-box">
            <button v-on:click="routeHome()" class="home-button"><p class="button-text">Home</p></button>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import ScorePredictorService from "../services/scorePredictorService";
    import moment from "moment";
    import {BIconChevronBarRight} from 'bootstrap-vue';

    export default {
        name: "Leaderboard",
        components: BIconChevronBarRight,
        data() {
            return {
                leaderboardTable: [],
            }
        },
        computed: mapState(['selectedRound', 'userData']),
        methods: {
            ...mapMutations(['setIsYourWinningsSelected', 'setSelectedRound', 'setLeaderBoardSportSelected', 'setLeaderboardSelectedUser', 'setSelectedSport']),

            onPlayerClicked(player) {
                this.setLeaderBoardSportSelected(player.DisplayName);
                this.setLeaderboardSelectedUser(player);

                if (player.DisplayName.includes('Soccer')) {
                    this.setSelectedSport('Soccer');
                    this.$router.push('predictions/soccer/view-predictions');
                }
                if (player.DisplayName.includes('OBFCC')) {
                    this.setSelectedSport('Olympics');
                    this.$router.push('predictions/olympics/view-predictions');
                }
                if (player.DisplayName.includes('Cricket')) {
                    this.setSelectedSport('Cricket');
                    this.$router.push('predictions/cricket/view-predictions');
                }
            },

            setTabState() {
                this.setIsYourWinningsSelected(true);
            },
            async getLeaderBoard() {
                const leaderBoard = await ScorePredictorService.getLeaderBoard(this.userData.msisdn, this.selectedRound);
                if (leaderBoard.recordset[leaderBoard.recordset.length - 2].MSISDN === this.userData.msisdn) leaderBoard.recordset.pop();
                this.leaderboardTable = leaderBoard.recordset
            },
            routeToRoundsBoard() {
                this.$router.push('/your-winnings')
            },
            formatDate(date) {
                return moment(date).format('DD/MM/YY');
            },
            routeHome() {
                this.setIsYourWinningsSelected(false);
                this.$router.push('/sports');
            },
            clearState() {
                this.leaderboardTable = [];
            }
        },
        mounted() {
            this.setTabState();
            this.clearState();
            this.getLeaderBoard(this.selectedRound)
        }
    }
</script>

<style scoped lang="scss">
    .winnings-container {
        display: flex;
        width: 90vw;
        background-color: rgba(129, 124, 124, 0.8);
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, .7),
        0 -0.25rem 1.5rem $winnings-table-background inset,
        0 0.75rem 0.5rem rgba(255, 255, 255, 0.4) inset,
        0 0.25rem 0.5rem 0 #ffffff inset;
        padding: 0.6rem 1rem 1.5rem 1rem;
        border-radius: 3px;
    }

    .winnings-table {
        width: 100%;
    }

    .back-button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 8vh;
        width: 300px;
        border-radius: 5px;
        background-color: Transparent;
        z-index: 0;
        margin-bottom: 2vh;
    }

    .chevron-bar-right {
        color: $current-predictions-home-button;
    }

    .player-names {
        text-align: left !important;
    }

    .table-row-data {
        height: auto;
        border-bottom: 1px solid #5d5d5d;
    }

    .table-row-header {
        border-bottom: 1px solid #5d5d5d;
    }

    .table-header-text {
        text-align: center;
        vertical-align: middle;
        font-size: 1rem;
        color: $winners-table-header-text-color;
        padding: 1.2rem 0;
        font-weight: 600;
    }

    .table-data-text {
        text-align: center;
        vertical-align: middle;
        font-size: 0.8rem;
        color: $winners-table-data-text-color;
        padding: 1rem 0;
    }

    @media screen and (max-width: 380px) {
        .table-header-text {
            font-size: 0.8rem;
        }

        .table-data-text {
            font-size: 0.6rem;
        }
    }

    @media screen and (max-width: 280px) {
        .table-header-text {
            font-size: 0.7rem;
        }

        .table-data-text {
            font-size: 0.5rem;
        }
    }

    .table-row-data:hover {
        background-color: rgba(80, 80, 80, 0.8);
        cursor: pointer;
    }

    .home-button-box {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 0;
        margin-right: 0;
        padding: 0;
        margin-top: 2vh;
    }

    .home-button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 8vh;
        width: 300px;
        border: solid $transperent-button-border-color 2px;
        border-radius: 5px;
        background-color: Transparent;
        z-index: 0;
        margin-bottom: 2vh;
    }

    .back-button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 8vh;
        width: 300px;
        border-radius: 5px;
        border: none !important;
        background-color: $current-predictions-home-button;;
        z-index: 0;
        margin-bottom: 1vh;
    }

    .button-text {
        color: $button-text-color;
        font-size: large;
        padding: 0;
        margin: 0;
    }

    .line-break {
        color: $line-break-color;
    }

</style>
